import { diversionAiCustomer } from '@/api/aiChat'
import { getCartList } from '@/api/content'
import { Env, getLocalStorage } from '@voghion/fe-util'
import { defineStore } from 'pinia'
import { ref } from 'vue'

const aiShoppingCacheKey = 'zoomies_ai_shopping_visible'
const storage = getLocalStorage()

/**
 * 智能导购
 */
export const useAiShoppingStore = defineStore('ai-shopping', () => {
  const cartCount = ref(0)
  const entryVisible = ref(!!storage.getItem(aiShoppingCacheKey))

  const getCartCount = async () => {
    try {
      const res = await getCartList({
        skipFlag: false
      })
      if (res?.data?.shoppingCartModelVOList) {
        const count = res.data.shoppingCartModelVOList.reduce((acc, curr) => acc + curr.cartGoods.length, 0)
        cartCount.value = count
      } else {
        cartCount.value = 0
      }
    } catch (error) {
      cartCount.value = 0
    }
  }

  const checkEntry = () => {
    diversionAiCustomer().then(
      (res) => {
        const env = Env.getInstance()
        if (res?.data && env.isApp()) {
          entryVisible.value = true
          storage.setItem(aiShoppingCacheKey, true)
        } else {
          entryVisible.value = false
          storage.removeItem(aiShoppingCacheKey)
        }
      },
      () => {}
    )
  }

  checkEntry()

  const clearCache = () => {
    storage.removeItem(aiShoppingCacheKey)
  }

  return {
    cartCount,
    getCartCount,
    entryVisible,
    clearCache
  }
})
